import { Box, Select, MenuItem, SxProps, Theme } from "@mui/material";
import { CONTROL_LABEL_SX } from "../../utils/control_label";

export const Measure = (props: {
  isLoading: boolean;
  sx?: SxProps<Theme>;
  measure: string;
  setMeasure: (measure: string) => void;
  columns: { name: string; caption: string }[];
  disabled: boolean;
}) => {
  const { sx, measure, setMeasure, columns, isLoading, disabled } = props;
  const columnValid = columns.some((c) => c.name === measure);

  return (
    <Box sx={sx}>
      <Box sx={CONTROL_LABEL_SX}>Aggregate by</Box>
      <Select
        disabled={isLoading || !columnValid || disabled}
        variant="outlined"
        size="small"
        fullWidth
        value={columnValid ? measure : ""}
        onChange={async (event) => {
          const newValue = event.target.value as string;
          setMeasure(newValue);
        }}
        sx={{
          borderRadius: "6px",
          backgroundColor: "#fff",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: (t) => t.palette.atomic.border,
          },
          "& .MuiSelect-select": { padding: "7px 10px" },
        }}
      >
        {columns.map((column, index) => (
          <MenuItem key={index} value={column.name}>
            {column.caption}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
